export const glCodeConstants = {
  API_BASE_PATH: 'v1/gl_codes',
  GET_ADMIN_GL_CODES: 'GET_ADMIN_GL_CODES',
  GET_ALL_GL_CODES: 'GET_ALL_GL_CODES',
  GET_CWF_GL_CODES: 'GET_CWF_GL_CODES',
  GET_RECENT_GL_CODES: 'GET_RECENT_GL_CODES',
};
